import React from 'react'
import { useSelector } from 'react-redux'

import { Typography } from 'antd'
import styled from 'styled-components'

import { Flex, icons } from 'portal/lib/primitives'

export const AssigneeNoRecordsAssigned = () => {
  const auth = useSelector((state: any) => state.auth)
  const { Title } = Typography

  return (
    <>
      <Flex.Row
        style={{
          width: '99.9%',
          alignItems: 'baseline',
          flex: '0 0 auto',
          marginBottom: '1.5rem'
        }}
      >
        <Title level={2} id="Heading">
          Welcome, {auth.userId}
        </Title>
        <Flex.By />
      </Flex.Row>
      <Section>
        <div>
          <Workers />
          <Title level={3} style={{ margin: '0.5rem 0 0' }}>
            It looks like you haven't been assigned to any records yet
          </Title>
          <Paragraph>
            You will be directed to the records page when you have been assigned
            records.
            <br />
            If this isn't what you expected to see, contact your Account
            Administrator.
          </Paragraph>
        </div>
      </Section>
    </>
  )
}

const Section = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;
  text-align: center;
  height: calc(100vh - 260px);

  div {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 720px;
  }
`
const Workers = styled(icons.Workers).attrs(() => ({
  style: undefined
}))`
  display: flex;
  flex: 0 0 auto;
  width: 50%;
  max-width: 300px;
  height: auto;
`
const Paragraph = styled.p`
  font-size: 1rem;
`
